import { useState } from "react";

export default function MobileCTABar() {
  const [showForm, setShowForm] = useState(false);
  const [formStatus, setFormStatus] = useState<"idle" | "submitting" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("submitting");
    const form = e.currentTarget;
    const data = new FormData(form);
    try {
      const response = await fetch("https://formspree.io/f/xojzbvwg", {
        method: "POST",
        body: (() => { const p = new URLSearchParams(data as unknown as Record<string, string>); p.append("formulario","Presupuesto (Móvil)"); p.append("_subject","Nuevo presupuesto (Móvil) — Persianas Málaga"); return p; })(),
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
      });
      if (response.ok) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("idle");
      }
    } catch {
      setFormStatus("idle");
    }
  };

  return (
    <>
      {/* Sticky CTA bar — mobile only */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-t border-background-200/80 py-2 px-3 flex items-center gap-2.5 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <a
          href="tel:+34951120770"
          className="flex items-center justify-center gap-1.5 bg-background-100 hover:bg-background-200 text-foreground-800 font-bold text-xs px-3.5 py-3 rounded-full transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer border border-background-200 flex-shrink-0"
        >
          <span className="w-4 h-4 flex items-center justify-center text-primary-500">
            <i className="ri-phone-fill"></i>
          </span>
          <span className="hidden sm:inline">951 12 07 70</span>
        </a>
        <button
          onClick={() => setShowForm(true)}
          className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-background-50 font-bold text-sm px-4 py-3 rounded-full transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer min-w-0"
        >
          Presupuesto gratis
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </button>
      </div>

      {/* Spacer to prevent content being hidden behind sticky bar */}
      <div className="md:hidden h-[72px]" />

      {/* Quick form modal */}
      {showForm && (
        <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={() => setShowForm(false)}>
          <div
            className="bg-background-50 rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 w-full sm:max-w-md shadow-2xl animate-[slideUp_0.25s_ease-out]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-bold text-foreground-950 font-heading">Pide presupuesto gratis</h3>
              <button onClick={() => setShowForm(false)} className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-700 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-close-line text-lg"></i></span>
              </button>
            </div>
            {formStatus === "success" ? (
              <div className="text-center py-6">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <span className="w-6 h-6 flex items-center justify-center"><i className="ri-check-line text-primary-600 text-xl"></i></span>
                </div>
                <p className="text-sm font-semibold text-foreground-900 mb-1">¡Presupuesto enviado!</p>
                <p className="text-xs text-foreground-600">Te contactaremos en menos de 15 minutos.</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-3.5">
                <div>
                  <label htmlFor="mobilecta-name" className="block text-xs font-medium text-foreground-800 mb-1">Nombre</label>
                  <input id="mobilecta-name" name="name" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 placeholder:text-foreground-400" placeholder="Tu nombre" />
                </div>
                <div>
                  <label htmlFor="mobilecta-phone" className="block text-xs font-medium text-foreground-800 mb-1">Teléfono</label>
                  <input id="mobilecta-phone" name="phone" type="tel" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 placeholder:text-foreground-400" placeholder="Tu teléfono" />
                </div>
                <div>
                  <label htmlFor="mobilecta-service" className="block text-xs font-medium text-foreground-800 mb-1">¿Qué necesitas?</label>
                  <select id="mobilecta-service" name="service" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 appearance-none cursor-pointer">
                    <option value="">Selecciona un servicio</option>
                    <option value="Persiana">Persiana</option>
                    <option value="Mosquiteras">Mosquiteras</option>
                    <option value="Motorización">Motorización</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                <button type="submit" disabled={formStatus === "submitting"} className="w-full py-3.5 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 disabled:from-primary-300 disabled:to-primary-300 text-background-50 font-semibold text-sm rounded-full transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer">
                  {formStatus === "submitting" ? "Enviando..." : "Solicitar presupuesto"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}